<template>
  <div class="width100 margin-auto">
    <div class="width100 margin-top10 flex-between cursorpointer">
      <span class="attention f14" @click="addNewlybuilt"> 新 增 </span>
      <el-button @click="dialogTableGanttchart = true"> 甘特图 </el-button>
    </div>

    <table class="width100 margin-auto backwihte margin-top20">
      <tr
        class="borderf1 borderleftnone hight40 f14"
        style="background: #e9e9e9"
      >
        <th class="borderf1 width8">序号</th>
        <th class="borderf1 borderleftnone width12">计划名</th>
        <th class="borderf1 borderleftnone width10">开始时间</th>
        <th class="borderf1 borderleftnone width10">截至时间</th>
        <th class="borderf1 borderleftnone width8">责任人</th>
        <th class="borderf1 borderleftnone width12">参与成员</th>
        <th class="borderf1 borderleftnone width20">计划目标</th>
        <th class="borderf1 borderleftnone width10">当前进度</th>
        <th class="borderf1 borderleftnone width10">操作</th>
      </tr>
      <tr
        class="f14 hight40 textalign-center"
        v-for="(item, index) in page"
        :key="index"
      >
        <td class="borderf1 bordertopnone width8">{{ index + 1 }}</td>
        <td class="table width12 text-ellipsis">{{ item.title }}</td>
        <td class="table width10">{{ item.start_date.substring(0, 10) }}</td>
        <td class="table width10">
          {{ item.end_date == null ? "" : item.end_date.substring(0, 10) }}
        </td>
        <td class="table width8">
          {{ item.user == null ? "" : item.user.nickname }}
        </td>
        <td class="table width12">
          <span
            v-for="(_item, _index) in item.participants"
            :key="_index"
            class="margin-right5"
            >{{ _item.realname }}</span
          >
        </td>
        <td class="table width20 lineheight25 pad-top10 pad-bot10">
          {{ item.remark }}
        </td>
        <td class="table width10">
          <span :class="item.progress * 100 >= 100 ? 'grenn' : 'perpo'"></span>
          {{ item.progress * 100 >= 100 ? "已完成" : "进行中" }}
        </td>
        <td class="table width10 cursorpointer bluecolor">
          <span @click="Tableedit(index)" class="margin-right10">编辑 </span>
          <span @click="Tabledetails(index)" class="margin-right10">详情 </span>
          <span @click="removepect(index)"> 删除</span>
        </td>
      </tr>
    </table>
    <el-dialog
      title=""
      :visible.sync="dialogVisiblenull"
      :close-on-click-modal="false"
      :show-close="true"
      :center="true"
      :modal="true"
      :modal-append-to-body="true"
      :append-to-body="true"
      width="25%"
      class="errorbox"
    >
      <p class="textalign-left f16">提示</p>
      <div class="textalign-left margin-top10">
        <span class="errormessage">{{ errormessage }}</span>
      </div>
      <span slot="footer" class="dialog-footer">
        <span @click="dialogVisiblenull = false" class="errorbutton">
          确 定
        </span>
      </span>
    </el-dialog>
    <!-- 新建计划 -->
    <el-dialog
      title=""
      :visible.sync="dialogTableNewlybuilt"
      :close-on-click-modal="false"
      :show-close="true"
      :center="true"
      append-to-body
      width="30%"
    >
      <div class="width100 backwihte">
        <div class="f16 width98 textalign-left dimensional">新建计划</div>
        <el-form
          ref="form"
          :model="forms"
          class="pad-top20 pad-bot10 flex-left"
        >
          <el-form-item label="归属计划" class="width100" prop="name">
            <el-select
              v-model="forms.parentname"
              class="width100"
              placeholder="请选择上级计划"
              :filterable="true"
            >
              <el-option label="---  请选择  ---" :value="0"></el-option>
              <el-option
                class="width100"
                v-for="item in options"
                :key="item.id"
                :label="item.title"
                :value="item.id"
              >
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="优先级" class="width100" prop="name">
            <el-select
              v-model="forms.priority"
              class="width100"
              placeholder="请选择优先级"
              :filterable="true"
            >
              <el-option label="---  请选择  ---" :value="0"></el-option>
              <el-option
                class="width100"
                v-for="item in priorityoptions"
                :key="item.val"
                :label="item.name"
                :value="item.val"
              >
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="计划名称" class="width100" prop="name">
            <el-input
              placeholder="请输入计划名称"
              v-model="forms.name"
              class="width100"
            ></el-input>
          </el-form-item>
          <el-form-item label="开始时间" class="width100" prop="date">
            <el-date-picker
              class="inputDeep"
              v-model="forms.date"
              type="date"
              placeholder="请选择开始时间"
              value-format="yyyy-MM-dd"
              :editable="false"
              style="width: 100%"
            ></el-date-picker>
          </el-form-item>
          <el-form-item label="结束时间" class="width100" prop="date">
            <el-date-picker
              class="inputDeep"
              v-model="forms.lastdate"
              type="date"
              placeholder="请选择结束时间"
              value-format="yyyy-MM-dd"
              :editable="false"
              style="width: 100%"
            ></el-date-picker>
          </el-form-item>
          <el-form-item label="责任人" class="width100 itemconten">
            <el-select
              v-model="userid"
              class="width100"
              placeholder="请选择责任人"
              :filterable="true"
            >
              <el-option label="---  请选择  ---" :value="0"></el-option>
              <el-option
                class="width100"
                v-for="item in pages"
                :key="item.user_id"
                :label="item.realname"
                :value="item.user_id"
              >
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="参与成员" class="width100 itemconten">
            <el-select
              v-model="articipants"
              class="width100"
              multiple
              placeholder="请选择"
              :filterable="true"
            >
              <el-option label="---  请选择  ---" :value="0"></el-option>
              <el-option
                class="width100"
                v-for="item in pages"
                :key="item.user_id"
                :label="item.realname"
                :value="item.user_id"
              >
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="当前进度" class="width100" prop="name">
            <el-slider
              class="width100 margin-top30"
              v-model="forms.progress"
            ></el-slider>
          </el-form-item>
          <el-form-item label="计划目标" class="width100">
            <el-input
              placeholder="请输入计划目标"
              type="textarea"
              :autosize="autosize"
              v-model="forms.desc"
              class="width100"
            ></el-input>
          </el-form-item>
        </el-form>
        <p class="determine">
          <el-button @click="dialogTableNewlybuilt = false">取 消</el-button>
          <el-button type="primary" @click="savesure()">确 定</el-button>
        </p>
      </div>
    </el-dialog>
    <!-- 编辑计划 -->
    <el-dialog
      title=""
      :visible.sync="dialogTableedit"
      :close-on-click-modal="false"
      :show-close="true"
      :center="true"
      append-to-body
      width="30%"
    >
      <div class="width100 backwihte">
        <div class="f16 width98 textalign-left dimensional">编辑计划</div>
        <el-form
          ref="form"
          :model="forms"
          class="pad-top20 pad-bot10 flex-left"
        >
          <el-form-item label="归属计划" class="width100" prop="name">
            <el-select
              v-model="forms.parentname"
              class="width100"
              placeholder="请选择上级计划"
              :filterable="true"
            >
              <el-option label="---  请选择  ---" :value="0"></el-option>
              <el-option
                class="width100"
                v-for="item in options"
                :key="item.id"
                :label="item.title"
                :value="item.id"
              >
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="优先级" class="width100" prop="name">
            <el-select
              v-model="forms.priority"
              class="width100"
              placeholder="请选择优先级"
              :filterable="true"
            >
              <el-option label="---  请选择  ---" :value="0"></el-option>
              <el-option
                class="width100"
                v-for="item in priorityoptions"
                :key="item.val"
                :label="item.name"
                :value="item.val"
              >
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="计划名称" class="width100" prop="name">
            <el-input
              placeholder="请输入计划名称"
              v-model="forms.name"
              class="width100"
            ></el-input>
          </el-form-item>
          <el-form-item label="开始时间" class="width100" prop="date">
            <el-date-picker
              class="inputDeep"
              v-model="forms.date"
              type="date"
              placeholder="请选择开始时间"
              value-format="yyyy-MM-dd"
              :editable="false"
              style="width: 100%"
            ></el-date-picker>
          </el-form-item>
          <el-form-item label="结束时间" class="width100" prop="date">
            <el-date-picker
              class="inputDeep"
              v-model="forms.lastdate"
              type="date"
              placeholder="请选择结束时间"
              value-format="yyyy-MM-dd"
              :editable="false"
              style="width: 100%"
            ></el-date-picker>
          </el-form-item>
          <el-form-item label="责任人" class="width100 itemconten">
            <el-select
              v-model="userid"
              class="width100"
              placeholder="请选择责任人"
              :filterable="true"
            >
              <el-option label="---  请选择  ---" :value="0"></el-option>
              <el-option
                class="width100"
                v-for="item in pages"
                :key="item.user_id"
                :label="item.realname"
                :value="item.user_id"
              >
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="参与成员" class="width100 itemconten">
            <el-select
              v-model="articipants"
              class="width100"
              multiple
              placeholder="请选择"
              :filterable="true"
            >
              <el-option label="---  请选择  ---" :value="0"></el-option>
              <el-option
                class="width100"
                v-for="item in pages"
                :key="item.user_id"
                :label="item.realname"
                :value="item.user_id"
              >
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="当前进度" class="width100" prop="name">
            <el-slider
              class="width100 margin-top30"
              v-model="forms.progress"
            ></el-slider>
          </el-form-item>
          <el-form-item label="计划目标" class="width100">
            <el-input
              placeholder="请输入计划目标"
              type="textarea"
              :autosize="autosize"
              v-model="forms.desc"
              class="width100"
            ></el-input>
          </el-form-item>
        </el-form>
        <p class="determine">
          <el-button @click="dialogTableedit = false">取 消</el-button>
          <el-button type="primary" @click="updatasure()">确 定</el-button>
        </p>
      </div>
    </el-dialog>
    <!-- 甘特图 -->
    <el-dialog
      title=""
      :visible.sync="dialogTableGanttchart"
      :close-on-click-modal="false"
      :show-close="true"
      :center="true"
      width="80%"
      append-to-body
    >
      <div class="width100 margin-auto pad-top5">
        <gantt></gantt>
      </div>
      <div slot="footer" class="dialog-footer textalign-right">
        <el-button @click="dialogTableGanttchart = false">取 消</el-button>
        <el-button type="primary" @click="dialogTableGanttchart = false"
          >确 定</el-button
        >
      </div>
    </el-dialog>
    <!-- 详情 -->
    <el-dialog
      title=""
      :visible.sync="dialogTabledetails"
      :close-on-click-modal="false"
      :show-close="true"
      :center="true"
      width="30%"
      append-to-body
    >
      <div class="f16 width98 textalign-left dimensional">计划详情</div>
      <div class="width100 margin-auto pad-top5">
        <div
          class="width100 pad-top20 flex-betweenwrap f14 lineheight35 dimencont"
        >
          <div class="width100">
            <span>计划名称：</span> <span>{{ detitle }}</span>
          </div>
          <div class="width100">
            <span>开始时间: </span>
            <span>{{
              destart_date == null ? "" : destart_date.substring(0, 10)
            }}</span>
          </div>
          <div class="width100">
            <span>截至时间: </span>
            <span>{{
              deend_date == null ? "" : deend_date.substring(0, 10)
            }}</span>
          </div>
          <div class="width100">
            <span>责任人: </span> <span>{{ derealname }}</span>
          </div>
          <div class="width100">
            <span>参与成员：</span>
            <span
              v-for="(item, index) in dearticipants"
              :key="index"
              class="margin-right5"
              >{{ item.realname }}</span
            >
          </div>
          <div class="width100">
            <span>计划目标： </span>
            <span>{{ deremark }}</span>
          </div>
          <div class="width100">
            <p>完成情况：</p>
            <el-input
              class="width100"
              type="textarea"
              :autosize="autosize"
              :rows="3"
              placeholder="请在这里输入完成情况"
              v-model="meaning"
              @blur="meaningblur"
            >
            </el-input>
          </div>

          <div class="width98 lineheight30 f12 pad-top10 margin-top20">
            <p
              class="
                bluecolor
                filebtnbg
                width98
                margin-auto
                flex-betweencen
                cursorpointer
              "
              v-for="(item, index) in defiles"
              :key="index"
            >
              <span @click="seafile(item)" class="width50 text-ellipsis"
                ><img src="@/assets/barsvg/icon／12fj.png" alt="" />
                {{ item.original_name }}</span
              >
              <span @click="meaningfilesremove(index)">
                <span class="removebtn"><i class="el-icon-close"></i></span>
              </span>
            </p>
            <p class="flex-betweennowrap">
              <span></span>
              <span>
                <el-button>
                  <el-upload
                    class="avatar-uploader"
                    :action="Apisrc"
                    name="file"
                    :show-file-list="false"
                    :on-success="meaninghandleAvatarSuccess"
                    :on-error="meaninghandleerror"
                    :data="meaninguser"
                    :headers="head"
                  >
                    添加附件
                  </el-upload>
                </el-button>
                <el-button @click="dialogTabledetails = false"
                  >关闭</el-button
                ></span
              >
            </p>
          </div>
        </div>
      </div>
    </el-dialog>
    <!-- 人员查找 -->
  </div>
</template>
<script>
import gantt from "../gantt/gantt.vue";
import { projecttaskindex, pipoList } from "@/api/Center/Center.api";
import {
  projecttaskdel,
  projecttasksave,
  projecttaskdetail,
  projecttaskremovefile,
  projecttaskmodifytarget,
  projecttaskupdate,
} from "@/api/loader/loder.api";
import { Base64 } from "js-base64";
export default {
  data() {
    return {
      autosize: {
        minRows: 3,
        maxRows: 1000,
      },
      errormessage: "",
      dialogVisiblenull: false,
      dialogTableNewlybuilt: false,
      dialogTableGanttchart: false,
      dialogTabledetails: false,
      dialogTableedit: false,
      user_id: "",
      form: {
        desc: "",
      },
      // 本项目对公司的作用与意义
      meaning: "",
      meaningfiles: [],
      meaningid: [],
      meaninguser: {
        task_id: "",
      },
      head: {
        token: window.sessionStorage.getItem("token"),
      },
      as: [],
      pages: [],
      userid: "",
      forms: {
        parentname: "",
        name: "",
        lastdate: "",
        date: "",
        desc: "",
        priority: "",
        progress: "",
      },
      options: [],
      priorityoptions: [
        {
          name: "高",
          val: 1,
        },
        {
          name: "中",
          val: 2,
        },
        {
          name: "低",
          val: 3,
        },
      ],
      Completionstatus: "",
      centerNum: "",
      page: [],
      duration: "",
      alliDay: "",
      detitle: "",
      destart_date: "",
      deend_date: "",
      derealname: "",
      dearticipants: [],
      articipants: [],
      deremark: "",
      defiles: "",
      percentage: 0,
      updateid: "",
      detaliid: "",
    };
  },
  components: {
    gantt,
  },
  methods: {
    seafile(item) {
      var url = window.g.Apisrc + item.url;
      window.open(
        window.g.previewurl + "?url=" + encodeURIComponent(Base64.encode(url))
      );
    },
    addNewlybuilt() {
      pipoList({
        dev_project_id: window.sessionStorage.getItem("centerNums"),
      }).then((res) => {
        if (res.data.code == 200) {
          this.pages = res.data.data;
        } else {
          this.dialogVisiblenull = true;
          this.errormessage = res.data.msg;
        }
      });
      this.dialogTableNewlybuilt = true;
      this.forms.name = "";
      this.forms.date = "";
      this.forms.lastdate = "";
      this.forms.progress = 0;
      this.forms.priority = "";
      this.forms.parentname = "";
      this.forms.desc = "";
      this.alliDay = "";
      this.userid = "";
      this.articipants = [];
    },
    DateDiff(sDate1, sDate2) {
      //sDate1和sDate2是2017-9-25格式
      var aDate, oDate1, oDate2, iDays;
      aDate = sDate1.split("-");
      oDate1 = new Date(aDate[1] + "-" + aDate[2] + "-" + aDate[0]); //转换为9-25-2017格式
      aDate = sDate2.split("-");
      oDate2 = new Date(aDate[1] + "-" + aDate[2] + "-" + aDate[0]);
      iDays = parseInt(Math.abs(oDate1 - oDate2) / 1000 / 60 / 60 / 24); //把相差的毫秒数转换为天数
      this.alliDay = iDays;
    },
    savesure() {
      this.DateDiff(this.forms.date, this.forms.lastdate);
      projecttasksave({
        project_id: window.sessionStorage.getItem("centerNums"),
        title: this.forms.name,
        start_date: this.forms.date,
        end_date: this.forms.lastdate,
        type: "task",
        open: 1,
        progress: this.forms.progress,
        priority: this.forms.priority,
        parent_id: this.forms.parentname == "" ? "0" : this.forms.parentname,
        duration: this.alliDay,
        user_id: this.userid,
        participants: this.articipants, //参与人id,
        remark: this.forms.desc,
      }).then((res) => {
        if (res.data.code == 200) {
          this.refresh();
          this.dialogTableNewlybuilt = false;
        } else {
          this.dialogVisiblenull = true;
          this.errormessage = res.data.msg;
        }
      });
    },
    Tableedit(index) {
      this.dialogTableedit = true;
      this.forms.name = this.page[index].title;
      this.forms.date = this.page[index].start_date;
      this.forms.lastdate = this.page[index].end_date;
      this.forms.progress = this.page[index].progress * 100;
      this.forms.priority = this.page[index].priority;
      this.forms.parentname = this.page[index].parent;
      this.forms.desc = this.page[index].remark;
      this.alliDay = this.page[index].duration;
      this.userid = this.page[index].user_id;
      this.articipants = [];
      this.page[index].participants.forEach((i) => {
        this.articipants.push(i.user_id);
      });
      this.updateid = this.page[index].id;
    },
    updatasure() {
      this.DateDiff(this.forms.date, this.forms.lastdate);
      projecttaskupdate({
        id: this.updateid,
        project_id: window.sessionStorage.getItem("centerNums"),
        title: this.forms.name,
        start_date: this.forms.date,
        end_date: this.forms.lastdate,
        type: "task",
        open: 1,
        progress: this.forms.progress,
        priority: this.forms.priority,
        parent_id: this.forms.parentname == "" ? "0" : this.forms.parentname,
        duration: this.alliDay,
        user_id: this.userid,
        participants: this.articipants, //参与人id,
        remark: this.forms.desc,
      }).then((res) => {
        if (res.data.code == 200) {
          this.refresh();
          this.dialogTableedit = false;
        } else {
          this.dialogVisiblenull = true;
          this.errormessage = res.data.msg;
        }
      });
    },

    removepect(index) {
      projecttaskdel({ id: this.page[index].id }).then((res) => {
        if (res.data.code == 200) {
          this.refresh();
        } else {
          this.dialogVisiblenull = true;
          this.errormessage = res.data.msg;
        }
      });
    },

    Tabledetails(index) {
      this.detaliid = this.page[index].id;
      this.dialogTabledetails = true;
      projecttaskdetail({ id: this.detaliid }).then((res) => {
        if (res.data.code == 200) {
          this.detitle = res.data.data.title;
          this.destart_date = res.data.data.start_date;
          this.deend_date = res.data.data.end_date;
          this.derealname = res.data.data.user.realname;
          this.deremark = res.data.data.remark;
          this.meaninguser.task_id = res.data.data.id;
          this.defiles = res.data.data.files;
          this.dearticipants = res.data.data.participants;
        } else {
          this.dialogVisiblenull = true;
          this.errormessage = res.data.msg;
        }
      });
    },
    // 文本框
    meaningblur() {
      projecttaskmodifytarget({
        task_id: this.meaninguser.task_id,
        remark: this.meaning,
      }).then((res) => {
        if (res.data.code == 200) {
          this.refresh();
          this.dialogTabledetails = false;
        } else {
          this.dialogVisiblenull = true;
          this.errormessage = res.data.msg;
        }
      });
    },
    // 上传附件
    meaninghandleAvatarSuccess(response, res, file) {
      if (response.msg == "上传文件后缀不允许") {
        this.dialogVisiblenull = true;
        this.errormessage = response.msg;
      } else {
        this.$message({
          showClose: true,
          message: "上传成功",
          type: "success",
        });
        projecttaskdetail({ id: this.detaliid }).then((res) => {
          if (res.data.code == 200) {
            this.defiles = res.data.data.files;
          } else {
            this.dialogVisiblenull = true;
            this.errormessage = res.data.msg;
          }
        });
      }
    },
    meaninghandleerror(error, file, fileList) {
      let myError = error.toString(); //转字符串
      myError = myError.replace("Error: ", ""); // 去掉前面的" Error: "
      myError = JSON.parse(myError); //转对象
      this.$loadings.hide(); // 隐藏loading
      this.dialogVisiblenull = true;
      this.errormessage = myError.msg;
    },
    // 附件删除
    meaningfilesremove(index) {
      projecttaskremovefile({
        file_id: this.defiles[index].id,
      }).then((res) => {
        if (res.data.code == 200) {
          projecttaskdetail({ id: this.detaliid }).then((res) => {
            if (res.data.code == 200) {
              this.defiles = res.data.data.files;
            } else {
              this.dialogVisiblenull = true;
              this.errormessage = res.data.msg;
            }
          });
        } else {
          this.dialogVisiblenull = true;
          this.errormessage = res.data.msg;
        }
      });
    },

    refresh() {
      this.$loading.show(); // 显示loading
      projecttaskindex({ project_id: this.centerNum, page: 1, limit: 30 }).then(
        (res) => {
          if (res.data.code == 200) {
            this.$loading.hide(); // 隐藏loading
            this.page = res.data.data.data;
            this.options = this.page;
          } else {
            this.$loading.hide(); // 隐藏loading
            this.dialogVisiblenull = true;
            this.errormessage = res.data.msg;
          }
        }
      );
    },
  },
  created() {
    this.Apisrc = window.g.ApiUrl + "/project_task/uploader";
    this.centerNum = window.sessionStorage.getItem("centerNums");
    projecttaskindex({ project_id: this.centerNum, page: 1, limit: 30 }).then(
      (res) => {
        if (res.data.code == 200) {
          this.page = res.data.data.data;
          this.options = this.page;
        } else {
          this.dialogVisiblenull = true;
          this.errormessage = res.data.msg;
        }
      }
    );
  },
};
</script>
<style scoped>
table {
  border-collapse: collapse;
  border-spacing: 0;
}
th {
  padding: 0;
}

.grenn {
  display: inline-block;
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background: #52c5cb;
  color: #52c5cb;
  position: relative;
  top: -1px;
  left: -5px;
}
.perpo {
  display: inline-block;
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background: #7b83ea;
  color: #7b83ea;
  position: relative;
  top: -1px;
  left: -5px;
}
.approvebtn {
  display: inline-block;
  width: 80px;
  height: 26px;
  line-height: 26px;
  border-radius: 4px;
  background-color: #c7c78c;
  color: rgba(255, 255, 255, 1);
  font-size: 12px;
  text-align: center;
  margin: 5px 0 0 5px;
}
.determine {
  text-align: right;
}
.lookup {
  width: 80px;
  border-radius: 5px;
  margin: 20px auto 0;
}

.table {
  border: 1px solid #f1f1f1;
  border-left: none;
  border-top: none;
}
.borderleftnone {
  border-left: none;
}
.bordertopnone {
  border-top: none;
}
.approvebtns {
  display: inline-block;
  width: 80px;
  height: 26px;
  line-height: 26px;
  border-radius: 4px;
  background-color: rgba(58, 126, 230, 1);
  color: rgba(255, 255, 255, 1);
  font-size: 12px;
  text-align: center;
  margin: 5px 0 0 0;
}

.preservation {
  width: 80px;
  height: 32px;
  line-height: 32px;
  border-radius: 5px;
}
.avatar-picture {
  width: 40px;
  height: 40px;
}
.removebtn {
  display: inline-block;
  width: 12px;
  height: 12px;
  color: #fff;
  background: #969eac;
  border-radius: 50%;
  position: relative;
  top: 3px;
}
.el-icon-close {
  font-size: 12px !important;
  position: absolute;
}
.filebtnbg {
  background: #f6f7fb;
  margin-bottom: 10px;
  padding: 3px 10px;
}
.nullinput >>> .el-input__inner {
  border: none;
  height: 38px;
}
.itemconten >>> .el-form-item__content {
  text-align: left;
}
.errorbox >>> .el-dialog__body {
  text-align: center;
}
.errorbox >>> .el-dialog {
  position: relative;
  top: 20%;
}
</style>